<template>
  <div>战队进程管理</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
